import { useMemo } from 'react';
import { canAccessRoute, getCurrentRoute, pwaRoutes } from '../routing/routes';
import { useAuth } from '../state/AuthProvider';

export function PwaNav() {
    const authContext = useAuth();
    const currentRoute = getCurrentRoute();

    const currentSection = pwaRoutes.find(
        route => currentRoute.path.startsWith(route.path)
    );

    const visibleRoutes = currentSection?.children ?? [];

    return (
        <nav aria-label="PWA Navigation">
            <div className="mb-4 flex items-center gap-3">
                <div>
                    <strong>{currentRoute.label}</strong>
                    <div className="text-sm text-gray-500">
                        {authContext.auth.user?.real_name ?? (authContext.auth.authenticated ? 'Simple Login' : 'Nicht angemeldet')}
                    </div>
                </div>
            </div>

            <div className="grid gap-2">
                {visibleRoutes.map((route) => (
                    <a
                        key={route.path}
                        href={route.path}
                        className={currentRoute.path === route.path
                            ? 'py-3 font-bold text-white'
                            : 'py-3 font-bold'}
                    >
                        <span className="block">{route.label}</span>
                        <span className="block text-xs opacity-75">{route.hint}</span>
                    </a>
                ))}
            </div>

            <div className="mt-4 pt-4">
                {authContext.auth.is_admin && (
                    <span className="ml-2 rounded-full bg-red-100 px-3 py-1 text-xs font-bold text-red-800">Admin</span>
                )}
            </div>

            {authContext.auth.authenticated && (
                <button
                    type="button"
                    onClick={() => void authContext.logout()}
                    className="mt-4 w-full rounded-xl border border-red-200 bg-red-50 px-4 py-2 font-bold text-red-800 hover:bg-red-100"
                >
                    Logout
                </button>
            )}
        </nav>
    );
}
